(function (app) {
    app.controller('EmployerSignDocumentsController',
        [
            '$scope',
            '$rootScope',
            '$stateParams',
            '$filter',
            '$state',
            'Upload',
            'hUser',
            'brandServices',
            function ($scope, $rootScope, $stateParams, $filter, $state, Upload, hUser, brandServices) {

                var cachedNeededAttribute = HStorageManager.get({
                    key: 'employer_sign_document_controller_data',
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                })
                var neededAttributed;

                if (!$stateParams.data || ($stateParams.data && !Object.keys($stateParams.data).length)) {
                    neededAttributed = cachedNeededAttribute;
                } else {
                    neededAttributed = $stateParams.data;
                }

                neededAttributed = neededAttributed || {};

                var brandId = $stateParams.brand_id;
                var positionId = neededAttributed.position_id;
                var userId = neededAttributed.user_id;
                var applicationId = neededAttributed.app_id;
                var jobId = neededAttributed.job_id;
                var prospectId = neededAttributed.prospect_id;

                $scope.DOCS_TYPES = OnBoardingAPI.DOCUMENT_TYPE;

                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'employer_sign_document_controller_data',
                    value: neededAttributed
                });

                if (!HStorageManager.get({
                    key: 'review_docs_prev_state',
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                })) {
                    var url;
                    var prevStateParams;

                    if ($rootScope.referal && $rootScope.referal.state && $rootScope.referal.state.name) {
                        url = $rootScope.referal.state.name;
                    }

                    if ($rootScope.referal && $rootScope.referal.params) {
                        prevStateParams = $rootScope.referal.params;
                    }

                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'review_docs_prev_state',
                        value: {url: url, params: prevStateParams}
                    });
                }

                var redirectLogic = function () {
                    //redirect to previous state or to dashboard
                    var goToState = 'appLayout.harriSH.dashboard';
                    var goToStateParam = {};

                    if (HStorageManager.get({
                        key: 'review_docs_prev_state',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    })) {
                        var data = angular.copy(HStorageManager.get({
                            key: 'review_docs_prev_state',
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                        }));

                        if (data.url) {
                            goToState = data.url;
                            goToStateParam = data.params;
                        }
                        if (goToState.toLowerCase() === 'docs') {
                            goToStateParam['user_id'] = userId;
                            goToStateParam['brand_id'] = brandId;
                        }

                        HStorageManager.remove({
                            key: 'review_docs_prev_state',
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                        })
                    }

                    $state.go(goToState, goToStateParam);
                };

                var isNotValid = !brandId || !positionId || !userId;

                if (!neededAttributed && !cachedNeededAttribute || isNotValid) {
                    var neededData = {
                        'position_id': 'required',
                        'user_id': 'required',
                        'prospect_id': 'if available send it',
                        'app_id': 'required on the ams',
                        'job_id': 'required on the ams'
                    };

                    var errorString = 'Needed attributed not sent please send the data on the route as ';
                    errorString += JSON.stringify(neededData);

                    console.error(Error(errorString, Date.now()));
                    redirectLogic();
                    return;
                }

                OnBoardingAPI.listDocuments(applicationId, prospectId, 'RIGHT_TO_WORK', null, true)
                    .then(function (data) {
                        var promises = {};

                        if (
                            data[0] &&
                            data[0].Document &&
                            data[0].Document.state === OnBoardingAPI.appStatuses.REQUESTED
                        ) {
                            promises['withdraw'] = OnBoardingAPI.deleteDocument(data[0].Document.id);
                        }

                        $q.all(promises)
                            .then(function (res) {
                                $scope.activeForm = new IdentityDocumentForm($scope, null, Upload, {id: brandId}, brandServices, hUser, false, jobId);
                                $scope.activeFormHTML = "../modules/hforms/candidate_onboarding/views/identity_document_form.html";
                                $scope.activeForm.load();

                                $scope.$digest();
                            });
                    });

                $scope.toggleInstructions = function() {
                    $scope.InstructionsOpen = !$scope.InstructionsOpen;
                }

                $scope.save = function () {

                    if ($scope.activeForm.validateFiles()) {
                        $scope.esigning = true;

                        var saveData = {
                            positionId:  positionId,
                            userId: userId,
                            applicationId: applicationId,
                            jobId: jobId,
                            prospectId: prospectId
                        };

                        $scope.activeForm.save(saveData)
                            .then(function (res) {
                                redirectLogic();
                            });
                    }

                };
            }
        ]);
})(angular.module('harriApp'));
